import ApiHandler from './ApiHandler'

export default {
  contactMsg: data => ApiHandler.post('contact', data),
  getContactList: () => ApiHandler.get('admin/support-data'),
  contactSupport: data => ApiHandler.post('contact', data)
}
